import {FormInitializer, InitializerKey, RawFormInitializer} from '../types';
import {FormLoaderError} from '@bff/loader-utils';

const initializers = new Map<string, FormInitializer>();

function getKey(key: InitializerKey): string {
    if (!key) {
        throw new FormLoaderError('A key must be supplied', 500);
    }
    if (!key.network || !key.property || !key.pageId) {
        throw new FormLoaderError('The key is missing required value(s): network, property, or pageId', 500);
    }

    return `${key.network}:${key.property}:${key.pageId}`;
}

export function registerInitializer(key: InitializerKey, rawFormInitializer: RawFormInitializer): void {
    const keyString = getKey(key);
    initializers.set(keyString, (container: HTMLElement)=> {
        return rawFormInitializer(container, false);
    });
}

export function getInitializer(key: InitializerKey): FormInitializer | undefined {
    const keyString = getKey(key);
    return initializers.get(keyString);
}

/**
 * Clears all registered initializers. Useful for testing to ensure test isolation.
 */
export function clearInitializers(): void {
    initializers.clear();
}
